import { capitalCase } from '@common/neo.tax';

import { State } from '../graphql/types';

/**
 * State options for use in a select element.
 *
 * In the future, the value should be the State enum value, not the two letter code.
 */
export const STATE_OPTIONS = [
  { label: capitalCase(State.Alabama), value: 'AL' },
  { label: capitalCase(State.Alaska), value: 'AK' },
  { label: capitalCase(State.AmericanSamoa), value: 'AS' },
  { label: capitalCase(State.Arizona), value: 'AZ' },
  { label: capitalCase(State.Arkansas), value: 'AR' },
  { label: capitalCase(State.California), value: 'CA' },
  { label: capitalCase(State.Colorado), value: 'CO' },
  { label: capitalCase(State.Connecticut), value: 'CT' },
  { label: capitalCase(State.Delaware), value: 'DE' },
  { label: capitalCase(State.DistrictOfColumbia), value: 'DC' },
  { label: capitalCase(State.FederatedStatesOfMicronesia), value: 'FM' },
  { label: capitalCase(State.Florida), value: 'FL' },
  { label: capitalCase(State.Georgia), value: 'GA' },
  { label: capitalCase(State.Guam), value: 'GU' },
  { label: capitalCase(State.Hawaii), value: 'HI' },
  { label: capitalCase(State.Idaho), value: 'ID' },
  { label: capitalCase(State.Illinois), value: 'IL' },
  { label: capitalCase(State.Indiana), value: 'IN' },
  { label: capitalCase(State.Iowa), value: 'IA' },
  { label: capitalCase(State.Kansas), value: 'KS' },
  { label: capitalCase(State.Kentucky), value: 'KY' },
  { label: capitalCase(State.Louisiana), value: 'LA' },
  { label: capitalCase(State.Maine), value: 'ME' },
  { label: capitalCase(State.MarshallIslands), value: 'MH' },
  { label: capitalCase(State.Maryland), value: 'MD' },
  { label: capitalCase(State.Massachusetts), value: 'MA' },
  { label: capitalCase(State.Michigan), value: 'MI' },
  { label: capitalCase(State.Minnesota), value: 'MN' },
  { label: capitalCase(State.Mississippi), value: 'MS' },
  { label: capitalCase(State.Missouri), value: 'MO' },
  { label: capitalCase(State.Montana), value: 'MT' },
  { label: capitalCase(State.Nebraska), value: 'NE' },
  { label: capitalCase(State.Nevada), value: 'NV' },
  { label: capitalCase(State.NewHampshire), value: 'NH' },
  { label: capitalCase(State.NewJersey), value: 'NJ' },
  { label: capitalCase(State.NewMexico), value: 'NM' },
  { label: capitalCase(State.NewYork), value: 'NY' },
  { label: capitalCase(State.NorthCarolina), value: 'NC' },
  { label: capitalCase(State.NorthDakota), value: 'ND' },
  { label: capitalCase(State.NorthernMarianaIslands), value: 'MP' },
  { label: capitalCase(State.Ohio), value: 'OH' },
  { label: capitalCase(State.Oklahoma), value: 'OK' },
  { label: capitalCase(State.Oregon), value: 'OR' },
  { label: capitalCase(State.Palau), value: 'PW' },
  { label: capitalCase(State.Pennsylvania), value: 'PA' },
  { label: capitalCase(State.PuertoRico), value: 'PR' },
  { label: capitalCase(State.RhodeIsland), value: 'RI' },
  { label: capitalCase(State.SouthCarolina), value: 'SC' },
  { label: capitalCase(State.SouthDakota), value: 'SD' },
  { label: capitalCase(State.Tennessee), value: 'TN' },
  { label: capitalCase(State.Texas), value: 'TX' },
  { label: capitalCase(State.Utah), value: 'UT' },
  { label: capitalCase(State.Vermont), value: 'VT' },
  { label: capitalCase(State.VirginIslands), value: 'VI' },
  { label: capitalCase(State.Virginia), value: 'VA' },
  { label: capitalCase(State.Washington), value: 'WA' },
  { label: capitalCase(State.WestVirginia), value: 'WV' },
  { label: capitalCase(State.Wisconsin), value: 'WI' },
  { label: capitalCase(State.Wyoming), value: 'WY' },
];
